import React, { useEffect } from 'react';
import { Flex } from 'antd';

import { useFilters } from '../../../../shops/features/products/hooks/useFilters';
import { FETCH_DELAY } from '../../../../crm/utils/common';
import { getInitialFilters } from '../utils/filters';
import { AddCommunity } from '../components/AddCommunity';
import { TableActions } from '../components/TableActions';
import {
    ChatFilters,
    ChatProps,
    COMMUNITY_TYPE,
} from '../interface/chats.interface';
import { ChatsTable } from '../components/ChatsTable';
import { useLazyReadChatsQuery } from '../service/chat.api';

export const ManageContainer = () => {
    const {
        filters,
        get: fetchChats,
        source,
        loading,
        updateFilters,
        getColumnSearchProps,
    } = useFilters<ChatFilters, ChatProps>(
        useLazyReadChatsQuery,
        getInitialFilters(COMMUNITY_TYPE.MANAGE)
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            const payload = {
                ...filters,
            };

            fetchChats(payload, true);
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, fetchChats]);

    const commonProps = {
        loading: loading,
        filters: filters,
        updateFilters: updateFilters,
    };

    return (
        <Flex vertical gap={24}>
            <AddCommunity updateFn={fetchChats} loading={loading} />
            <TableActions
                communityType={COMMUNITY_TYPE.MANAGE}
                {...commonProps}
            />
            <ChatsTable
                source={source || []}
                getColumnSearchProps={getColumnSearchProps}
                {...commonProps}
            />
        </Flex>
    );
};
